export const PERFORMANCE_RULE_EXECUTED_ACTIONS_REPORT_ID = 'performance-rule-executed-actions';
